import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '../../../../../services/translate/translate.service';
import { ServerApiService } from '../../../../../server-api/server-api.service';
import { LogService } from '../../../../../services/log/log.service';
import { OperationError } from '../../../../../models/server-result/operation-error';
import { OperationResult } from '../../../../../models/server-result/operation-result';
import { HttpErrorResponse } from '@angular/common/http';
import { ToasterService } from '../../../../../shared-components/custom-toaster/toaster.service';
import { UtilitiesService } from '../../../../../services/utils/utilities.service';
import { FactoringCreditAssignmentRecordsUploadTemplateResult } from '../../../../../models/upload/factoring-credit-assignment/factoring-credit-assignment-records-upload-template-result';

@Component({
	selector: 'app-factoring-credit-assignment-template',
	templateUrl: './factoring-credit-assignment-template.component.html',
	styleUrls: ['./factoring-credit-assignment-template.component.css'],
	standalone: false,
})
export class FactoringCreditAssignmentTemplateComponent {
	public isPerformingRequest = false;
	public validationErrors: OperationError[] = [];

	constructor(
		private translateService: TranslateService,
		private serverApiService: ServerApiService,
		private logger: LogService,
		private toasterService: ToasterService,
		private utilitiesService: UtilitiesService,
		public router: Router
	) {}

	public downloadTemplate() {
		const serviceCall = this.serverApiService.generateFactoringCreditAssignmentRecordsUploadTemplate();
		this.isPerformingRequest = true;
		serviceCall.subscribe({
			next: (operationResult: OperationResult<FactoringCreditAssignmentRecordsUploadTemplateResult>) => {
				this.isPerformingRequest = false;
				if (operationResult.IsValid) {
					this.processValidFactoringCreditAssignmentRecordsUploadTemplateResult(operationResult);
				} else {
					this.processInValidFactoringCreditAssignmentRecordsUploadTemplateResult(operationResult);
				}
			},
			error: (httpErrorResponse: HttpErrorResponse) => {
				this.isPerformingRequest = false;
				this.logger.error(
					'[FactoringCreditAssignmentUploadStep1Component::generateFactoringCreditAssignmentRecordsUploadTemplate] HttpErrorResponse: ',
					httpErrorResponse
				);
				this.toasterService.showError(
					'[FactoringCreditAssignmentUploadStep1Component::generateFactoringCreditAssignmentRecordsUploadTemplate] HttpErrorResponse: ' +
						httpErrorResponse.error +
						httpErrorResponse.message
				);
			},
		});
	}

	private processInValidFactoringCreditAssignmentRecordsUploadTemplateResult(
		operationResult: OperationResult<FactoringCreditAssignmentRecordsUploadTemplateResult>
	) {
		const errors = operationResult.Errors;

		if (errors && errors.length > 0) {
			this.toasterService.showError(this.translateService.translate('VALIDATION_FAILED', 'list-errorCodes'), {
				errors: errors,
				autoClose: false,
			});
		}
	}

	private processValidFactoringCreditAssignmentRecordsUploadTemplateResult(
		operationResult: OperationResult<FactoringCreditAssignmentRecordsUploadTemplateResult>
	) {
		const blob = this.utilitiesService.base64ToBlob(operationResult.Data.Content, operationResult.Data.ContentType);

		//strategy from https://stackoverflow.com/questions/19327749/javascript-blob-filename-without-link
		const element = document.createElement('a');
		element.href = URL.createObjectURL(blob);
		element.download = operationResult.Data.ContentName;
		document.body.appendChild(element);
		element.click();
	}

	public clickGotoUploadStep(): void {}

	public navigateToUploadStep1(): void {
		this.router.navigate(['/private/files-upload/upload/factoringcreditassignment/step1']);
	}
}
